import { Link, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import styled from 'styled-components';

const BrandingText = styled.h1`
	color: ${(props) => (props.$isInner ? 'white' : 'black')} !important;
`;

const TaglineText = styled.p`
	color: ${(props) => (props.$isInner ? 'white' : 'black')} !important;
`;

const Branding = ({ className = '', brandingClassName = '', taglineClassName = '', onLinkClick, $isInner = false }) => {
	const navigate = useNavigate();

	const handleClick = useCallback(
		(e) => {
			console.log('🔍 Branding Link clicked, isInner:', $isInner);

			if ($isInner) {
				console.log('🔍 Inside inner condition');
				e.preventDefault();
				e.stopPropagation();

				if (onLinkClick) {
					console.log('🔍 Calling onLinkClick callback');
					onLinkClick();
				}

				console.log('🔍 Setting timeout for navigation');
				setTimeout(() => {
					console.log('🔍 Navigating to home');
					navigate('/');
				}, 300);
			}
		},
		[$isInner, onLinkClick, navigate]
	);

	return (
		<div className={`flex flex-col gap-2 md:flex-row branding ${className}`}>
			<Link to="/" onClick={handleClick} style={$isInner ? { pointerEvents: 'all' } : undefined}>
				<BrandingText $isInner={$isInner} className={`font-trade-compressed relative text-[1.5625rem] font-bold leading-[1.61288rem] tracking-[0.15625rem] uppercase ${brandingClassName}`}>
					The Progressive Corporation
				</BrandingText>
			</Link>
			<TaglineText $isInner={$isInner} className={`font-late-serif relative text-[1.25rem] font-normal leading-[1.49888rem] tracking-[0.0375rem] mt-[6px] ${taglineClassName}`}>
				2025 Shareholders’ Report
			</TaglineText>
		</div>
	);
};

export default Branding;
